var map = {
	"./authentication/reducer.js": 2493,
	"./database/reducer.js": 2494,
	"./dialog/reducer.js": 2495,
	"./drawer/reducer.js": 2496,
	"./entity/reducer.js": 2497,
	"./mapbox/reducer.js": 2498,
	"./popover/reducer.js": 2499,
	"./storage/reducer.js": 2500,
	"./theme/reducer.js": 2501
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2492;


//////////////////
// WEBPACK FOOTER
// ./src/interface/store/departments \.\/.+\/reducer\.js$
// module id = 2492
// module chunks = 1